import type {InviaType} from '@/redux/v1/models';

export const areAllBoardTypesEqual = (rooms: Array<{boardType: InviaType}>) => {
  return rooms.every((room) => room.boardType.type === rooms[0].boardType.type);
};
